export const DISTANCE_OPTIONS = [10, 30, 50, 70, 90, 110, 130, 150];
